import { render, staticRenderFns } from "./MingCheng.vue?vue&type=template&id=d5e072a6&scoped=true&"
import script from "./MingCheng.vue?vue&type=script&lang=js&"
export * from "./MingCheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e072a6",
  null
  
)

export default component.exports